import * as React from "react"

const SvgComponent = (props) => (
  <svg
    width={15}
    height={10}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.5 10 .139.25H14.86L7.5 10Z" fill="#636F7C" />
  </svg>
)

export default SvgComponent
